import { Container, Ticker } from "pixi.js"
import Entity, { CollisionType } from "./Entity"
import Level from "./Level"
import { TILE_SIZE, SCALE_FACTOR } from "./config"
import { getAnimation } from "./spritesheet"
import Match from "./Match"

export type ExplosionType = "fireEndTop" | "fireEndBottom" | "fireEndLeft" | "fireEndRight" | "fireMiddleVertical" | "fireMiddleHorizontal" | "fireMiddleCross"

export default class Explosion extends Entity {
  static EXPLOSION_SIZE = TILE_SIZE * SCALE_FACTOR
  static VERTICAL_TYPES = ["fireEndTop", "fireEndBottom", "fireMiddleVertical"]
  static HORIZONTAL_TYPES = ["fireEndLeft", "fireEndRight", "fireMiddleHorizontal"]

  private _type: ExplosionType
  get type() {
    return this._type
  }
  set type(value) {
    this._type = value
    this.textures = getAnimation(value)
    this.play()
  }

  constructor(params: { x: number, y: number, type: ExplosionType, level: Level }) {
    super({
      x: params.x,
      y: params.y,
      level: params.level,
      speed: 0,
      width: Explosion.EXPLOSION_SIZE,
      height: Explosion.EXPLOSION_SIZE,
      textures: getAnimation(params.type),
      staticTileCoords: true
    })

    this.play()
    this.animationSpeed = 0.3
    this._type = params.type
    this.loop = false
    this.onComplete = () => this.removeFromLevel()
  }

  tickUpdate(ticker: Ticker) {
    super.tickUpdate(ticker)
    if (this.level instanceof Match && !this.level.started) return
    this.level.checkCollisions(this, CollisionType.HitBox).forEach(e => this.collide(e, CollisionType.HitBox))
  }

  collide(entity: Container | Entity, type: CollisionType): void {
    if (this.level instanceof Match && !this.level.started) return
    super.collide(entity, type)
    if (entity instanceof Entity && type === CollisionType.HitBox) {
      entity.explode()
    }
  }

  toString() {
    return "Explosion"
  }
}
